import { BulkActionButtonComponent } from 'commons/components/bulk-action-button/bulk-action-button.component';
import { useTranslation } from 'core/i18n/i18n';

export interface BulkEditCustomAlarmsComponentProps {
    onClick: VoidFunction;
}

export const BulkEditCustomAlarmsComponent: React.FC<BulkEditCustomAlarmsComponentProps> = (props) => {
    const { t } = useTranslation();
    const { onClick } = props;

    return (
        <BulkActionButtonComponent
            text={t('settings.devices.custom-alarms.actions.edit')}
            iconName="write"
            onClick={onClick}
        />
    );
};
